import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import CommonPricePlanCalculator from 'common/components/entities/PricePlanCalculator'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import React from 'react'

type PricePlanCalculatorProps = {
  entity: PricePlanCalculatorInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function PricePlanCalculator({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: PricePlanCalculatorProps) {
  const locale = usePresentPage(selectors.getPageLocale)
  return (
    <BaseEntity
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonPricePlanCalculator locale={locale} openPopup={() => undefined} />
    </BaseEntity>
  )
}

export default PricePlanCalculator
